import instance from "../axios";

export const getPrograms = async (partnerID) => {
    const response = await instance.get(
        "programs/GetAllActivePrograms.php?partnerID=" + partnerID
    );

    return response.data;
};